export class PaymentHistoryModel {
    public amount!: number;
    public createBy!: string;
    public createDate!: string;
    public id!: number;
    public modifiedBy!: string;
    public modifiedDate!: string;
    public orderId!: number;
    public orderType!: number;
    public status!: number;
    public statusDetail?: any;
    public type!: number;
    public typeName!: any;
    public uId!: number;
}

